import { TagItem, UserItem } from './../../../public/app/models/Item';
import { Component, OnInit } from '@angular/core';
import { DbmanagerService } from '../services/dbmanager.service';
import { FieldType } from '../models/Item';
import { DatePipe } from '@angular/common';

export enum ReportType {None, CSV, PDF}
export enum ReportColum {Type, Locations, Markers, Headers}

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})

export class ReportsComponent implements OnInit {

  Data = new Map([
    [FieldType.RFIDNumber, $localize`:@@itemdetails.rfidNumber:Numer RFID`],
    [FieldType.EvidNumber, $localize`:@@itemdetails.inventoryNr:Numer Inwentaryzacyjny`],
    [FieldType.Category, $localize`:@@itemdetails.category:Numer Kategoria`],
    [FieldType.Mark, $localize`:@@itemdetails.mark:Marka`],
    [FieldType.PurchaseDate, $localize`:@@itemdetails.purchasedate:Data Zakupu`],
    [FieldType.Size, $localize`:@@itemdetails.size:Rozmiar`],
    [FieldType.Link, $localize`:@@itemdetails.link:Link`],
    [FieldType.State, $localize`:@@itemdetails.state:Ilość/Stan`],
    [FieldType.Location, $localize`:@@itemdetails.location:Lokalizacja`],
    [FieldType.Remarks, $localize`:@@itemdetails.remarks:Uwagi`],
    [FieldType.Description, $localize`:@@itemdetails.desc:Opis`],
    [FieldType.Title, $localize`:@@itemdetails.title:Tytuł`],
    [FieldType.LastUser, $localize`:@@itemslist.lastuser:Ostatni użytkownik`],
    [FieldType.LastEntry, $localize`:@@itemslist.lastentry:Ostatni wpis`]
  ]);

  markersHidden = true;
  locationsHidden = true;
  headersHidden = true;
  reportType = ReportType;
  reportColum = ReportColum;
  report = ReportType.None;
  generateAvailable: boolean ;
  constructor(private dbService: DbmanagerService) { }
  locations: Array<string>;
  selectedLocations: Array<string>;
  selectedHeaders: Array<number>;
  selectedTags: Array<string>;
  markers: Array<string>;
  headers: Map<FieldType, string>;
  ngOnInit(): void {
    this.locations = new  Array<string>();
    this.selectedLocations = new  Array<string>();
    this.selectedHeaders = new  Array<number>();
    this.selectedTags = new  Array<string>();
    this.markers = new  Array<string>();
    this.headers = new Map<FieldType, string>();
    this.generateAvailable = false;
  }

  chooseReport(type: ReportType) {
    this.report = type ;
    this.locationsHidden = false;
    this.locations = new  Array<string>();
    this.dbService.locations.forEach(loc => {
      this.locations.push(loc.NAME);
    });
  }

  markAllLocation(event, locs) {
    if (event === true) {
      locs.selectAll();
      this.locationsChanged(locs.selectedOptions.selected);
    } else {
      locs.deselectAll();
      this.locationsChanged(locs.selectedOptions.selected);
    }
  }

  markAllTags(event, tags) {
    if (event === true) {
      tags.selectAll();
    } else {
      tags.deselectAll();
    }
  }

  markAll(event, items, colum: ReportColum) {
    if (event === true) {
      items.selectAll();
      if (colum === ReportColum.Locations) {
        this.markersHidden = false;
        this.locationsChanged(items.selectedOptions.selected);
      } else if (colum === ReportColum.Markers) {
        this.headersHidden = false;
        this.tagsChanged(items.selectedOptions.selected);
      } else if (colum === ReportColum.Headers) {
        this.generateAvailable = true;
        this.selectedHeaders = new  Array<number>();
        this.headers.forEach((value: string, key: number) => {
          this.selectedHeaders.push(key);
        });
      }
    } else {
      items.deselectAll();
      this.generateAvailable = false;
      if (colum === ReportColum.Locations) {
        this.markersHidden = true;
        this.headersHidden = true;
        this.headers = new Map<FieldType, string>();
        this.selectedHeaders = new  Array<number>();
        this.locationsChanged(items.selectedOptions.selected);
      } else if (colum === ReportColum.Markers) {
        this.headersHidden = true;
        this.tagsChanged(items.selectedOptions.selected);
      }
    }
  }

  tagsChanged(selectedTags) {
    if (selectedTags.length === 0) {
      this.headersHidden = true;
      this.generateAvailable = false;
      this.headers = new Map<FieldType, string>();
    } else {
      this.headersHidden = false;
      this.headers = this.Data;
      this.selectedTags = new  Array<string>();
      for (const a of selectedTags) {
        this.selectedTags.push(a.value);
      }
    }
  }

  headersChanged(selectedHeaders) {
    if (selectedHeaders.length === 0) {
      this.generateAvailable = false;
    } else {
      this.generateAvailable = true;
      this.selectedHeaders = new  Array<number>();
      for (const a of selectedHeaders) {
        this.selectedHeaders.push(a.value.key);
      }
    }
  }

  locationsChanged(selectedOptions) {
    if (selectedOptions.length === 0) {
      this.markersHidden = true;
      this.headers = new Map<FieldType, string>();
      this.headersHidden = true;
      this.generateAvailable = false;
    } else {
      this.markersHidden = false;
    }
    this.selectedLocations = new  Array<string>();
    this.markers = new Array<string>();
    for (const a of selectedOptions) {
      this.selectedLocations.push(a.value);
    }

    this.dbService.eventItems.forEach( event => {
      if (this.selectedLocations.includes(event.LOCATION)) {
        this.markers.push(event.TAG_UID);
      }
    });
  }

  generateReport() {
    const obj = new Array<TagItem>();
    this.dbService.tagItems.forEach(tag => {
      if (this.selectedTags.includes(tag.TAG_UID)) {
        obj.push(this.generateRow(tag));
      }
    });
    this.exportToCsv('file.csv', obj);
  }

  generateRow(tag: TagItem) {
    let row = new Object();
    if (this.selectedHeaders.includes(FieldType.RFIDNumber)) {
      row = Object.assign(row, {[this.Data.get(FieldType.RFIDNumber)]: tag.TAG_UID});
    }
    if (this.selectedHeaders.includes(FieldType.EvidNumber)) {
      row = Object.assign(row, {[this.Data.get(FieldType.EvidNumber)]: tag.REG_NUM});
    }
    if (this.selectedHeaders.includes(FieldType.Title)) {
      row = Object.assign(row, {[this.Data.get(FieldType.Title)]: tag.TITLE});
    }
    if (this.selectedHeaders.includes(FieldType.Description)) {
      row = Object.assign(row, {[this.Data.get(FieldType.Description)]: tag.DESCRIPTION});
    }
    if (this.selectedHeaders.includes(FieldType.Category)) {
      row = Object.assign(row, {[this.Data.get(FieldType.Category)]: tag.CATEGORY});
    }
    if (this.selectedHeaders.includes(FieldType.Mark)) {
      row = Object.assign(row, {[this.Data.get(FieldType.Mark)]: tag.MARK});
    }
    if (this.selectedHeaders.includes(FieldType.PurchaseDate)) {
      const date =  (Object)(tag.PURCHASE_DATE) ;
      try {
        row = Object.assign(row, {[this.Data.get(FieldType.PurchaseDate)]: new DatePipe('PL').transform(date.toDate(), 'medium')});
      } catch {
        console.log('Date Err');
      }

    }
    if (this.selectedHeaders.includes(FieldType.Size)) {
      row = Object.assign(row, {[this.Data.get(FieldType.Size)]: tag.SIZE});
    }
    if (this.selectedHeaders.includes(FieldType.Link)) {
      row = Object.assign(row, {[this.Data.get(FieldType.Link)]: tag.LINK});
    }
    if (this.selectedHeaders.includes(FieldType.State)) {
      row = Object.assign(row, {[this.Data.get(FieldType.State)]: this.dbService.eventItems.get(tag.TAG_UID).STATE});
    }
    if (this.selectedHeaders.includes(FieldType.Location)) {
      row = Object.assign(row, {[this.Data.get(FieldType.Location)]: this.dbService.eventItems.get(tag.TAG_UID).LOCATION});
    }
    if (this.selectedHeaders.includes(FieldType.Remarks)) {
      row = Object.assign(row, {[this.Data.get(FieldType.Remarks)]: this.dbService.eventItems.get(tag.TAG_UID).REMARKS});
    }

    if (this.selectedHeaders.includes(FieldType.LastUser)) {
      const ev = this.dbService.eventItems.get(tag.TAG_UID);
      let user: UserItem ;
      if (tag.EDIT_DATETIME > ev.EVENT_DATETIME) {
        user = this.dbService.users.get(tag.USER_ID);
      } else {
        user = this.dbService.users.get(ev.USER_ID);
      }
      row = Object.assign(row, {[this.Data.get(FieldType.LastUser)]: user.NAME + ' ' + user.SURNAME});
    }

    if (this.selectedHeaders.includes(FieldType.LastEntry)) {
      const ev = this.dbService.eventItems.get(tag.TAG_UID);
      let date =   (Object)(ev.EVENT_DATETIME) ;
      if (tag.EDIT_DATETIME > ev.EVENT_DATETIME) {
        date =  (Object)(tag.EDIT_DATETIME) ;
      }
      row = Object.assign(row, {[this.Data.get(FieldType.LastEntry)]: new DatePipe('PL').transform(date.toDate(), 'medium')});
    }

    return row;
  }

  // ta funkcje można wrzucić do innej klashy
  exportToCsv(filename: string, rows: object[]) {
    if (!rows || !rows.length) {
      return;
    }
    const separator = ',';
    const keys = Object.keys(rows[0]);
    const csvContent =
      keys.join(separator) +
      '\n' +
      rows.map(row => {
        return keys.map(k => {
          let cell = row[k] === null || row[k] === undefined ? '' : row[k];
          cell = cell instanceof Date
            ? cell.toLocaleString()
            : cell.toString().replace(/"/g, '""');
          if (cell.search(/("|,|\n)/g) >= 0) {
            cell = `"${cell}"`;
          }
          return cell;
        }).join(separator);
      }).join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      const link = document.createElement('a');
      if (link.download !== undefined) {
        // Browsers that support HTML5 download attribute
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

}
